import { z } from 'zod';

export const ADMIN_V2_ALLOWED_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
] as const;

export const ADMIN_V2_IMAGE_COLOR_MODES = ['rgb', 'rgba'] as const;

export const ADMIN_V2_IMAGE_MIME_TYPE_OPTION_KEYS = {
  'image/jpeg': 'jpeg',
  'image/png': 'png',
  'image/webp': 'webp',
} as const satisfies Record<AdminV2AllowedImageMimeType, string>;

export const ADMIN_V2_IMAGE_COLOR_MODE_OPTION_KEYS = {
  rgb: 'rgb',
  rgba: 'rgba',
} as const satisfies Record<AdminV2ImageColorMode, string>;

export type AdminV2AllowedImageMimeType =
  (typeof ADMIN_V2_ALLOWED_IMAGE_MIME_TYPES)[number];

export type AdminV2ImageColorMode = (typeof ADMIN_V2_IMAGE_COLOR_MODES)[number];

export const adminV2AllowedImageMimeTypeSchema = z.enum(
  ADMIN_V2_ALLOWED_IMAGE_MIME_TYPES
);

export const adminV2ImageColorModeSchema = z.enum(ADMIN_V2_IMAGE_COLOR_MODES);

export function isAdminV2AllowedImageMimeType(
  value: string
): value is AdminV2AllowedImageMimeType {
  return ADMIN_V2_ALLOWED_IMAGE_MIME_TYPES.includes(
    value as AdminV2AllowedImageMimeType
  );
}

export function isAdminV2ImageColorMode(
  value: string
): value is AdminV2ImageColorMode {
  return ADMIN_V2_IMAGE_COLOR_MODES.includes(value as AdminV2ImageColorMode);
}
